import { GREY_CHALLENGE, NOTE_CAUGHT, NOTE_CLEARED, NOTE_KING_SAVED, TYPE_MASK, challengeNote, isNeutral, movePromo, pieceDef } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const GREY = '/art/grey.svg';
const isChallenge = (m: number) => movePromo(m) === GREY_CHALLENGE;

export const greyUi: VariantUi = {
  heroImage: GREY,
  peek: [{}, { image: '/art/gK.svg' }, {}, {}, { image: '/art/gN.svg', threat: true }, {}, {}, { image: '/art/gQ.svg' }, {}],
  boardClass: 'grey',
  // Captured pieces and the material lead would say whose pieces were taken.
  hideMaterial: true,

  boardAction: (m) => !isChallenge(m),

  actions(_pos, legal) {
    const m = legal.find(isChallenge);
    return m === undefined ? [] : [{ label: 'Challenge!', move: m, tone: 'danger', title: 'Was that really their piece? If not, the move is taken back.' }];
  },

  pieceImage(_pos, _sq, piece) {
    if (!piece || isNeutral(piece)) return null;
    return `/art/g${pieceDef(piece & TYPE_MASK).letter.toUpperCase()}.svg`;
  },

  pieceLabel(_pos, _sq, piece) {
    return `grey ${pieceDef(piece & TYPE_MASK).name}`;
  },

  twist(pos, you) {
    const note = challengeNote(pos);
    const mine = you === null || pos.turn === you;
    if (note === NOTE_CAUGHT) return { text: mine ? 'Caught! That wasn’t their piece. The move is taken back, and it’s your turn.' : 'Caught! The move is taken back.', alert: true };
    if (note === NOTE_CLEARED) return { text: mine ? 'Fair move! The challenge failed, so you go again.' : 'That move was fair. The challenger loses their turn.', alert: true };
    if (note === NOTE_KING_SAVED) return { text: 'Nice try: you can’t take a king with their own piece. Taken back.', alert: true };
    return { text: mine ? 'Move any piece (even theirs!) or challenge their last move.' : 'Remember which pieces are yours…' };
  },

  eventSound(e) {
    if (e.t !== 'fx') return null;
    return e.kind === 'caught' ? 'betray' : e.kind === 'cleared' ? 'boing' : null;
  },
};
